import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-finalizar-servicio',
  templateUrl: './finalizar-servicio.component.html',
  styleUrls: ['./finalizar-servicio.component.sass']
})
export class FinalizarServicioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
